const objeto = (value) => {
  if (typeof value === "string") {
    try {
      return objeto(JSON.parse(value));
    } catch {
      return {};
    }
  }
  return value && typeof value === "object" && !Array.isArray(value) ? value : {};
};
export const codigoConcesionUsuario = (user) =>
  String(objeto(user?.user?.more).code ?? objeto(user?.more).code ?? "").trim();

// Read identity from the signed-in account, never from more.id (audit actor).
export function identidadUsuarioConcesion(user, token) {
  const profile = user?.user || user;
  let id = profile?.id;
  let username = profile?.username;
  if (id == null && (token || user?.token)) {
    try {
      const encoded = (token || user.token).split(".")[1].replace(/-/g, "+").replace(/_/g, "/");
      const claims = JSON.parse(atob(encoded));
      id = claims.id;
      username = username || claims.username;
    } catch {
      // An opaque token cannot identify an account; no unscoped lookup follows.
    }
  }
  return { id: id == null ? "" : String(id), username: String(username || "").trim() };
}

// A code is a business identifier, not a commerce ID. Preserve leading zeroes.
export function perteneceConcesion(registro, concesion) {
  if (!concesion?.code) return false;
  const code = registro?.concesion?.code ?? registro?.concesion_code ?? registro?.code;
  if (code != null) return String(code).trim() === concesion.code;
  const id = registro?.concesion?.id ?? registro?.concesion_id;
  return id != null && String(id) === String(concesion.id);
}

export function rolUsuarioConcesion(user) {
  const role = user?.role ?? user?.user?.role;
  return String(typeof role === "string" ? role : role?.name || "")
    .trim()
    .toLowerCase();
}
